import React, { memo } from "react";
import { PinIcon, ClockIcon, SparkleIcon } from "./icons";

function SuggestionIcon({ type }) {
    if (type === "recent") return <ClockIcon size={15} color="#94a3b8" />;
    if (type === "ai") return <SparkleIcon size={15} color="#f97316" />;
    return <PinIcon size={15} color="#94a3b8" />;
}

const SuggestionsDropdown = memo(function SuggestionsDropdown({
                                                                  listboxId,
                                                                  items,
                                                                  highlightedIndex,
                                                                  onHover,
                                                                  onSelect,
                                                                  heading,
                                                                  dropdownRef,
                                                              }) {
    if (!items.length) return null;

    return (
        <div className="suggestions-dropdown" role="listbox" id={listboxId} ref={dropdownRef}>
            {heading && <p className="suggestions-heading">{heading}</p>}
            {items.map((item, index) => (
                <button
                    key={item.id}
                    id={`${listboxId}-opt-${item.id}`}
                    type="button"
                    role="option"
                    aria-selected={index === highlightedIndex}
                    className={`suggestion-item${index === highlightedIndex ? " highlighted" : ""}`}
                    onMouseEnter={() => onHover(index)}
                    onMouseDown={(e) => e.preventDefault()} // keep input focused, fire before blur
                    onClick={() => onSelect(item)}
                >
                    <span className="suggestion-icon"><SuggestionIcon type={item.type} /></span>
                    <span className="suggestion-label">{item.label}</span>
                </button>
            ))}
        </div>
    );
});

export default SuggestionsDropdown;